import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-2_29Y5EDNsa",
  ClientId: "2eg1i31hkcnrr01sjkirvvib3m",
};

export default new CognitoUserPool(poolData);
